const TOKEN = "token-access";
const REMEMBER_ME = "remember-me";
const LANGUAGE_REMEMBER = 'language-remember';

export { TOKEN, REMEMBER_ME, LANGUAGE_REMEMBER };
